// Theme type definitions

export type ThemeId = 'light' | 'dark' | 'midnight';
export type ThemePreference = ThemeId | 'system';

export interface ThemeConfig {
  id: ThemeId;
  name: string;
  monacoTheme: string;
}

export const THEMES: Record<ThemeId, ThemeConfig> = {
  light: {
    id: 'light',
    name: 'Light',
    monacoTheme: 'vs',
  },
  dark: {
    id: 'dark',
    name: 'Dark',
    monacoTheme: 'vs-dark',
  },
  midnight: {
    id: 'midnight',
    name: 'Midnight',
    monacoTheme: 'vs-dark',
  },
};

export const THEME_PREFERENCES: { id: ThemePreference; name: string }[] = [
  { id: 'system', name: 'System' },
  { id: 'light', name: 'Light' },
  { id: 'dark', name: 'Dark' },
  { id: 'midnight', name: 'Midnight' },
];
